import { sub, getUnixTime, setSeconds } from 'date-fns';

export const trimSec = (date) => getUnixTime(new Date(setSeconds(sub(date, { hours: 3 }), 0)));
